import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  envName: {
    display: 'flex',
    flexFlow: 'column',

    '& div': {
      display: 'flex',
      flexFlow: 'column'
    },

    '& input': {
      marginLeft: '0.325rem',
      border: 'none',
      outline: 'none',
      margin: '5px 0px',
      minWidth: '35%',
      borderBottom: '1px solid black',
      fontSize: theme.size.sm,

      [theme.breakpoints.down('md')]: {
        minWidth: '60%'
      }
    },

    '& small': {
      color: 'red',
      margin: '2px 0px'
    }
  },

  title: {
    fontSize: theme.size.sm
  },

  dropdown: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0',

    '& > :first-child': {
      marginRight: '0.5rem'
    },

    '& .menu': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.border.outline}`,
      borderRadius: '5px',
      boxSizing: 'border-box',
      padding: '0.25rem',

      '& > :first-child': {
        color: theme.palette.textAlt,
        marginRight: '1rem'
      }
    }
  },

  fieldValue: {
    color: '#323436'
  },

  status: {
    justifyContent: 'unset',
    cursor: 'pointer',
    fontSize: theme.size.sm
  }
}))

export default useStyles
